// Studyo Today Curriculum
// Package studyo.today.curriculum.v1
// Service definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.3 with parameter "import_extension=js"
// @generated from file studyo/today/curriculum/v1/curriculum.proto (package studyo.today.curriculum.v1, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_studyo_today_curriculum_v1_resources_course } from "./resources/course_pb.js";

/**
 * Describes the file studyo/today/curriculum/v1/curriculum.proto.
 */
export const file_studyo_today_curriculum_v1_curriculum = /*@__PURE__*/
  fileDesc("CitzdHVkeW8vdG9kYXkvY3VycmljdWx1bS92MS9jdXJyaWN1bHVtLnByb3RvEhpzdHVkeW8udG9kYXkuY3VycmljdWx1bS52MSJTChJHZXRDb3Vyc2VzUmVzcG9uc2USPQoHY291cnNlcxgBIAMoCzIsLnN0dWR5by50b2RheS5jdXJyaWN1bHVtLnYxLnJlc291cmNlcy5Db3Vyc2UiMQobR2V0RW5yb2xsZWRDb3Vyc2VJZHNSZXF1ZXN0EhIKCnBsYW5uZXJfaWQYASABKAkiMgocR2V0RW5yb2xsZWRDb3Vyc2VJZHNSZXNwb25zZRISCgpjb3Vyc2VfaWRzGAEgAygJIkUKG1NldEVucm9sbGVkQ291cnNlSWRzUmVxdWVzdBISCgpwbGFubmVyX2lkGAEgASgJEhIKCmNvdXJzZV9pZHMYAiADKAkiVAocU2V0RW5yb2xsZWRDb3Vyc2VJZHNSZXNwb25zZRIYChBhZGRlZF9jb3Vyc2VfaWRzGAEgAygJEhoKEnJlbW92ZWRfY291cnNlX2lkcxgCIAMoCTKAAwoKQ3VycmljdWx1bRJWCgpHZXRDb3Vyc2VzEhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5Gi4uc3R1ZHlvLnRvZGF5LmN1cnJpY3VsdW0udjEuR2V0Q291cnNlc1Jlc3BvbnNlIgASiwEKFEdldEVucm9sbGVkQ291cnNlSWRzEjcuc3R1ZHlvLnRvZGF5LmN1cnJpY3VsdW0udjEuR2V0RW5yb2xsZWRDb3Vyc2VJZHNSZXF1ZXN0Gjguc3R1ZHlvLnRvZGF5LmN1cnJpY3VsdW0udjEuR2V0RW5yb2xsZWRDb3Vyc2VJZHNSZXNwb25zZSIAEosBChRTZXRFbnJvbGxlZENvdXJzZUlkcxI3LnN0dWR5by50b2RheS5jdXJyaWN1bHVtLnYxLlNldEVucm9sbGVkQ291cnNlSWRzUmVxdWVzdBo4LnN0dWR5by50b2RheS5jdXJyaWN1bHVtLnYxLlNldEVucm9sbGVkQ291cnNlSWRzUmVzcG9uc2UiAEIiqgIfU3R1ZHlvLlRvZGF5LkN1cnJpY3VsdW0uR3JwYy5WMWIGcHJvdG8z", [file_google_protobuf_empty, file_studyo_today_curriculum_v1_resources_course]);

/**
 * Describes the message studyo.today.curriculum.v1.GetCoursesResponse.
 * Use `create(GetCoursesResponseSchema)` to create a new message.
 */
export const GetCoursesResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_curriculum_v1_curriculum, 0);

/**
 * Describes the message studyo.today.curriculum.v1.GetEnrolledCourseIdsRequest.
 * Use `create(GetEnrolledCourseIdsRequestSchema)` to create a new message.
 */
export const GetEnrolledCourseIdsRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_curriculum_v1_curriculum, 1);

/**
 * Describes the message studyo.today.curriculum.v1.GetEnrolledCourseIdsResponse.
 * Use `create(GetEnrolledCourseIdsResponseSchema)` to create a new message.
 */
export const GetEnrolledCourseIdsResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_curriculum_v1_curriculum, 2);

/**
 * Describes the message studyo.today.curriculum.v1.SetEnrolledCourseIdsRequest.
 * Use `create(SetEnrolledCourseIdsRequestSchema)` to create a new message.
 */
export const SetEnrolledCourseIdsRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_curriculum_v1_curriculum, 3);

/**
 * Describes the message studyo.today.curriculum.v1.SetEnrolledCourseIdsResponse.
 * Use `create(SetEnrolledCourseIdsResponseSchema)` to create a new message.
 */
export const SetEnrolledCourseIdsResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_curriculum_v1_curriculum, 4);

/**
 * API definition for the Today Curriculum service.
 *
 * @generated from service studyo.today.curriculum.v1.Curriculum
 */
export const Curriculum = /*@__PURE__*/
  serviceDesc(file_studyo_today_curriculum_v1_curriculum, 0);

